import React, { PureComponent } from 'react';
import WND from './WND.js';
import ICONS from './ICONS';
import MENUBAR from './menus/MENUBAR';
import './NOTEPAD.css';

let menu = [
    { text: "File", accel: "F" },
    { text: "Edit", accel: "E" },
    { text: "Search", accel: "S" },
    { text: "Help", accel: "H" }
];

class NOTEPAD extends WND {
    constructor(props) {
        super(props);

        if (this.props.commandLine) {
            this.state.info = window.WINAPI.GetFileInfo(this.props.commandLine);
            this.state.contents = window.WINAPI.OpenFile(this.props.commandLine);
        } else {
            this.state.info = null;
            this.state.contents = "";
        }

        this.state.dirty = false;
    }

    applicationContent() {
        return <div className="notepad">
            <MENUBAR menu={menu} />

            <textarea value={this.state.contents} spellCheck="false" onChange={(e) => {
                this.setState({
                    contents: e.target.value,
                    dirty: true
                })
            }} />
        </div>;
    }

    icon() {
        return ICONS.TEXTFILE_16;
    }

    title() {
        return (this.state.info ? this.state.info.name : "Untitled") + " - Notepad";
    }
}

export default NOTEPAD;


// WEBPACK FOOTER //
// ./src/walleris/NOTEPAD.js